import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useUnsavedChanges } from "~/providers/unsaved-changes-provider";
import { useVatRateStore } from "~/stores/use-vat-rate-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import VatRateForm from "./vat-rate-form";

export default function VatRateDialog() {
  const {
    vatRateFormOpen,
    setVatRateFormOpen,
    setSelectedVatRate,
    selectedVatRate,
    isLoading,
  } = useVatRateStore();

  const { t } = useTranslation("common");

  const { checkUnsavedChanges } = useUnsavedChanges();

  const handleDialog = (open: boolean, force?: boolean) => {
    if (open === false) {
      if (force !== true) {
        const result = checkUnsavedChanges();
        if (result === true) return;
      }
      setSelectedVatRate(undefined);
    }
    setVatRateFormOpen(open);
  };

  return (
    <Dialog open={vatRateFormOpen} onOpenChange={handleDialog}>
      <DialogContent className="max-w-xl w-full">
        <DialogHeader>
          <DialogTitle>{t("VatRate.vat_rate")}</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <ScrollArea className="max-h-[80vh] p-4">
          <VatRateForm
            vatRate={selectedVatRate}
            onClose={(force) => handleDialog(false, force)}
          />
        </ScrollArea>
        <DialogFooter>
          <Button
            className="w-full"
            disabled={isLoading}
            form="vat-rate-form"
            type="submit"
            variant="success"
          >
            {selectedVatRate ? t("update") : t("create")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
